import { AccessDeniedError } from '@ibinder/common-utils';

const accessChecker = (fn) => {
  let data = fn;

  if (data.error?.message.includes('Received status code 403')) {
    throw new AccessDeniedError();
  }

  return data;
};

export const customApolloMiddleware = (checkFn) => (apolloFn) =>
  checkFn(apolloFn);

//Convenience fn's applying the appropriate checker.
export const accessCheck = customApolloMiddleware(accessChecker);
